import type { Session } from '@supabase/supabase-js'
import { createContext, use } from 'react'
import type { AccessState } from '../../types/domain'

export type AuthContextValue = {
  session: Session | null
  access: AccessState | null
  loading: boolean
  error: Error | null
  mfaRequired: boolean
  refreshAccess: () => Promise<void>
  refreshMfa: () => Promise<void>
  logout: () => Promise<void>
}

export const AuthContext = createContext<AuthContextValue | null>(null)

export function useAuth() {
  const context = use(AuthContext)
  if (!context) throw new Error('useAuth mesti digunakan dalam AuthProvider.')
  return context
}
